// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","id":"1"},"2":{"path":"/iosIndex","redirect":"/","id":"2"},"3":{"path":"/androidIndex","redirect":"/","id":"3"},"4":{"path":"/worktopIos","redirect":"/","id":"4"},"5":{"path":"/worktopAndroid","redirect":"/","id":"5"},"6":{"path":"/DisposeAccount","redirect":"/","id":"6"},"7":{"path":"/guideModal","redirect":"/","id":"7"},"8":{"path":"/feedback-modal","redirect":"/","id":"8"},"9":{"path":"/feedback","redirect":"/","id":"9"},"10":{"path":"*","redirect":"/","id":"10"}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__index__index" */'@/pages/index/index.tsx')),
'2': React.lazy(() => import('./EmptyRoute')),
'3': React.lazy(() => import('./EmptyRoute')),
'4': React.lazy(() => import('./EmptyRoute')),
'5': React.lazy(() => import('./EmptyRoute')),
'6': React.lazy(() => import('./EmptyRoute')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import('./EmptyRoute')),
'9': React.lazy(() => import('./EmptyRoute')),
'10': React.lazy(() => import('./EmptyRoute')),
},
  };
}
